import get from 'transmute/get';
export const getIndexedAsyncMoveStatuses = get('moveStatuses');